import { useState, useEffect, useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import ForgeViewer from 'react-forge-viewer'

import { getSelectedGalleryItemId } from '@tabeeb/modules/gallery/selectors'
import { getAutodeskData } from '@tabeeb/modules/contentViewer/selectors'
import * as contentViewerActions from '@tabeeb/modules/contentViewer/actions'
import { autodeskHubName } from '@tabeeb/modules/signalr/services/constants'
import { getIsContentReadonly } from '@tabeeb/modules/readonlyWhiteboard/selectors'
import { SignalRContextProvider } from '@tabeeb/modules/signalr'

import { subscribeToAutodeskUpdates, unsubscribeFromAutodeskUpdates } from './signalr'

import LoadingProgressBar from '../LoadingProgressBar'

const AutodeskViewer = () => {
  const dispatch = useDispatch()
  const [view, setView] = useState(null)
  const selectedPageId = useSelector(getSelectedGalleryItemId)
  const autodeskData = useSelector(getAutodeskData)
  const isContentReadonly = useSelector(getIsContentReadonly)

  useEffect(() => {
    if (!isContentReadonly) {
      dispatch(contentViewerActions.getAutodeskViewable.request(selectedPageId))
    }
  }, [dispatch, selectedPageId, isContentReadonly])

  const handleTokenRequested = (onAccessToken) => {
    if (onAccessToken) {
      onAccessToken(autodeskData.Token.AccessToken, autodeskData.Token.ExpiresIn)
    }
  }

  const onConnectedToHub = useCallback(() => {
    dispatch(subscribeToAutodeskUpdates({ pageId: selectedPageId }))
  }, [dispatch, selectedPageId])

  const onDisconnectingFromHub = useCallback(() => {
    dispatch(unsubscribeFromAutodeskUpdates({ pageId: selectedPageId }))
  }, [dispatch, selectedPageId])

  return (
    <SignalRContextProvider
      enabled={!isContentReadonly}
      hubName={autodeskHubName}
      onConnected={onConnectedToHub}
      onDisconnecting={onDisconnectingFromHub}
    >
      {autodeskData &&
        (autodeskData.IsReady ? (
          <ForgeViewer
            urn={autodeskData.Urn}
            view={view}
            onTokenRequest={handleTokenRequested}
            onDocumentLoad={(_, viewables) => setView(viewables[0])}
            onDocumentError={() => {}}
          />
        ) : (
          <LoadingProgressBar
            value={autodeskData.ProgressPercentage || 0}
            text='Please wait, the model is getting ready'
          />
        ))}
    </SignalRContextProvider>
  )
}

export default AutodeskViewer
